// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Sidebar from "../Layout/Sidebar";
// import Header from "../Layout/Header";
// import Swal from "sweetalert2";
// import axios from "axios";
// import "./AddTenantModuleEntitlement.css";
// import { API_BASE } from "../../../ApiUrl";
// import SubscriptionTabs from "../TenantSubscription/SubscriptionTabs";

// const API_URL = `${API_BASE}/tenant-module-entitlements/`;
// const MODULES_API_URL = `${API_BASE}/modules/`;

// const STATUS_OPTIONS = [
//   { value: "ACTIVE", label: "Active" },
//   { value: "INACTIVE", label: "Inactive" },
//   { value: "SUSPENDED", label: "Suspended" },
//   { value: "EXPIRED", label: "Expired" }
// ];

// const emptyEntitlement = {
//   module: "",
//   status: "ACTIVE",
//   limits: "{}",
//   effective_from: "",
//   effective_to: ""
// };

// const toDateInput = (value) => (value ? String(value).substring(0, 10) : "");

// const AddTenantModuleEntitlement = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const editEntitlement = location.state?.editEntitlement || null;
//   const isEditMode = Boolean(editEntitlement?.id);

//   const [entitlements, setEntitlements] = useState(() => {
//     if (editEntitlement) {
//       return [
//         {
//           module: editEntitlement.module || "",
//           status: editEntitlement.status || "ACTIVE",
//           limits:
//             editEntitlement.limits !== null &&
//             editEntitlement.limits !== undefined
//               ? JSON.stringify(editEntitlement.limits)
//               : "{}",
//           effective_from: toDateInput(editEntitlement.effective_from),
//           effective_to: toDateInput(editEntitlement.effective_to)
//         }
//       ];
//     }

//     return [{ ...emptyEntitlement }];
//   });

//   const [modulesList, setModulesList] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [loadingModules, setLoadingModules] = useState(false);

//   const getTenantUser = () => {
//     try {
//       const tenantUser = localStorage.getItem("tenant_user");
//       return tenantUser ? JSON.parse(tenantUser) : null;
//     } catch (error) {
//       console.error("Error reading tenant_user:", error);
//       return null;
//     }
//   };

//   // Load the shared Module master list for the dropdown
//   useEffect(() => {
//     const fetchModules = async () => {
//       try {
//         setLoadingModules(true);
//         const response = await axios.get(MODULES_API_URL);
//         const data = Array.isArray(response.data)
//           ? response.data
//           : response.data.results || [];
//         setModulesList(data);
//       } catch (error) {
//         console.error("Error fetching modules:", error);
//         Swal.fire({
//           icon: "error",
//           title: "Unable to Load Modules",
//           text: "Could not fetch the module list. Please refresh the page."
//         });
//       } finally {
//         setLoadingModules(false);
//       }
//     };

//     fetchModules();
//   }, []);

//   const handleChange = (index, e) => {
//     const { name, value } = e.target;
//     setEntitlements((prev) =>
//       prev.map((ent, i) => (i === index ? { ...ent, [name]: value } : ent))
//     );
//   };

//   const addEntitlement = () => {
//     if (isEditMode) return;
//     setEntitlements((prev) => [...prev, { ...emptyEntitlement }]);
//   };

//   const removeEntitlement = (index) => {
//     if (isEditMode || entitlements.length === 1) return;
//     setEntitlements((prev) => prev.filter((_, i) => i !== index));
//   };

//   const parseLimits = (raw) => {
//     const trimmed = (raw || "").trim();
//     if (!trimmed) return {};
//     const parsed = JSON.parse(trimmed);
//     if (typeof parsed !== "object" || Array.isArray(parsed) || parsed === null) {
//       throw new Error("Limits must be a JSON object.");
//     }
//     return parsed;
//   };

//   const validateRow = (ent, index) => {
//     const label = `Entitlement ${index + 1}`;

//     if (!ent.module) {
//       Swal.fire({
//         icon: "warning",
//         title: "Required Field Missing",
//         text: `Please select a Module for ${label}.`
//       });
//       return false;
//     }

//     if (!ent.status) {
//       Swal.fire({
//         icon: "warning",
//         title: "Required Field Missing",
//         text: `Please select a Status for ${label}.`
//       });
//       return false;
//     }

//     try {
//       parseLimits(ent.limits);
//     } catch (err) {
//       Swal.fire({
//         icon: "warning",
//         title: "Invalid Limits JSON",
//         text: `Limits for ${label} must be a valid JSON object (e.g. {"max_users": 50}).`
//       });
//       return false;
//     }

//     if (
//       ent.effective_from &&
//       ent.effective_to &&
//       ent.effective_to < ent.effective_from
//     ) {
//       Swal.fire({
//         icon: "warning",
//         title: "Invalid Dates",
//         text: `Effective To for ${label} cannot be before Effective From.`
//       });
//       return false;
//     }

//     return true;
//   };

//   const buildPayload = (ent, tenantUser) => ({
//     module: ent.module,
//     status: ent.status,
//     limits: parseLimits(ent.limits),
//     effective_from: ent.effective_from || null,
//     effective_to: ent.effective_to || null,
//     tenant: tenantUser.tenant_id,
//     user: tenantUser.user_id
//   });

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const tenantUser = getTenantUser();

//     if (!tenantUser) {
//       Swal.fire({
//         icon: "error",
//         title: "Session Information Missing",
//         text: "Tenant user information was not found in local storage."
//       });
//       return;
//     }

//     if (!tenantUser.tenant_id || !tenantUser.user_id) {
//       Swal.fire({
//         icon: "error",
//         title: "Invalid Tenant User",
//         text: "Tenant ID or User ID is missing from tenant_user."
//       });
//       return;
//     }

//     for (let i = 0; i < entitlements.length; i++) {
//       if (!validateRow(entitlements[i], i)) return;
//     }

//     // Duplicate module check within the form
//     const moduleIds = entitlements.map((ent) => String(ent.module));
//     const duplicateIndex = moduleIds.findIndex(
//       (id, i) => moduleIds.indexOf(id) !== i
//     );

//     if (duplicateIndex !== -1) {
//       Swal.fire({
//         icon: "warning",
//         title: "Duplicate Module",
//         text: "The same module is selected more than once. Please remove duplicates."
//       });
//       return;
//     }

//     try {
//       setLoading(true);

//       if (isEditMode) {
//         const payload = buildPayload(entitlements[0], tenantUser);

//         console.log("Update Tenant Module Entitlement Payload:", payload);

//         const response = await axios.put(
//           `${API_URL}${editEntitlement.id}/`,
//           payload,
//           { headers: { "Content-Type": "application/json" } }
//         );

//         console.log("Update Tenant Module Entitlement Response:", response.data);

//         await Swal.fire({
//           icon: "success",
//           title: "Entitlement Updated Successfully",
//           text: "Tenant module entitlement has been updated successfully.",
//           confirmButtonText: "OK"
//         });

//         navigate("/admin/module-entitlements");
//         return;
//       }

//       const payload = entitlements.map((ent) => buildPayload(ent, tenantUser));

//       console.log("Create Tenant Module Entitlements Payload:", payload);

//       const response = await axios.post(API_URL, payload, {
//         headers: { "Content-Type": "application/json" }
//       });

//       console.log("Create Tenant Module Entitlements Response:", response.data);

//       await Swal.fire({
//         icon: "success",
//         title: "Entitlements Created Successfully",
//         text: `${entitlements.length} entitlement${
//           entitlements.length > 1 ? "s" : ""
//         } created successfully.`,
//         confirmButtonText: "OK"
//       });

//       navigate("/admin/module-entitlements");
//     } catch (error) {
//       console.error(
//         isEditMode
//           ? "Update Tenant Module Entitlement Error:"
//           : "Create Tenant Module Entitlements Error:",
//         error
//       );

//       let errorMessage = isEditMode
//         ? "Unable to update tenant module entitlement."
//         : "Unable to create tenant module entitlements.";

//       if (error.response?.data) {
//         if (typeof error.response.data === "string") {
//           errorMessage = error.response.data;
//         } else if (error.response.data.detail) {
//           errorMessage = error.response.data.detail;
//         } else if (error.response.data.message) {
//           errorMessage = error.response.data.message;
//         } else if (error.response.data.errors) {
//           errorMessage = Object.entries(error.response.data.errors)
//             .map(
//               ([field, errors]) =>
//                 `${field}: ${
//                   Array.isArray(errors) ? errors.join(", ") : errors
//                 }`
//             )
//             .join(" | ");
//         } else {
//           errorMessage = JSON.stringify(error.response.data);
//         }
//       }

//       Swal.fire({
//         icon: "error",
//         title: isEditMode ? "Update Failed" : "Save Failed",
//         text: errorMessage
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCancel = () => {
//     navigate("/admin/module-entitlements");
//   };

//   return (
//     <div className="app-layout">
//       <Sidebar />

//       <div className="main-content">
//         <Header />

//         <div className="tenant-entitlement-page">
//           <SubscriptionTabs/>
//           <div className="tenant-entitlement-page-header">
//             <div>
//               <h2>
//                 {isEditMode
//                   ? "Edit Module Entitlement"
//                   : "Create Module Entitlement"}
//               </h2>
//               <p>
//                 {isEditMode
//                   ? "Update tenant module entitlement information."
//                   : "Add one or multiple module entitlements for the tenant."}
//               </p>
//             </div>
//           </div>

//           <form onSubmit={handleSubmit}>
//             <div className="tenant-entitlement-card">
//               <div className="tenant-entitlement-form-body">
//                 {entitlements.map((ent, index) => (
//                   <div className="tenant-entitlement-record" key={index}>
//                     <div className="tenant-entitlement-record-header">
//                       <div>
//                         <h4>
//                           {isEditMode
//                             ? "Entitlement Details"
//                             : `Entitlement ${index + 1}`}
//                         </h4>
//                       </div>

//                       {!isEditMode && entitlements.length > 1 && (
//                         <button
//                           type="button"
//                           className="tenant-entitlement-remove-btn"
//                           onClick={() => removeEntitlement(index)}
//                         >
//                           Remove
//                         </button>
//                       )}
//                     </div>

//                     <div className="tenant-entitlement-form-grid">
//                       <div className="tenant-entitlement-form-group">
//                         <label>
//                           Module <span>*</span>
//                         </label>
//                         <select
//                           name="module"
//                           value={ent.module}
//                           onChange={(e) => handleChange(index, e)}
//                           required
//                           disabled={loadingModules}
//                         >
//                           <option value="">
//                             {loadingModules
//                               ? "Loading modules..."
//                               : "Select module"}
//                           </option>
//                           {modulesList.map((mod) => (
//                             <option key={mod.id} value={mod.id}>
//                               {mod.name} ({mod.code})
//                             </option>
//                           ))}
//                         </select>
//                       </div>

//                       <div className="tenant-entitlement-form-group">
//                         <label>
//                           Status <span>*</span>
//                         </label>
//                         <select
//                           name="status"
//                           value={ent.status}
//                           onChange={(e) => handleChange(index, e)}
//                           required
//                         >
//                           {STATUS_OPTIONS.map((opt) => (
//                             <option key={opt.value} value={opt.value}>
//                               {opt.label}
//                             </option>
//                           ))}
//                         </select>
//                       </div>

//                       <div className="tenant-entitlement-form-group">
//                         <label>Effective From</label>
//                         <input
//                           type="date"
//                           name="effective_from"
//                           value={ent.effective_from}
//                           onChange={(e) => handleChange(index, e)}
//                         />
//                       </div>

//                       <div className="tenant-entitlement-form-group">
//                         <label>Effective To</label>
//                         <input
//                           type="date"
//                           name="effective_to"
//                           value={ent.effective_to}
//                           onChange={(e) => handleChange(index, e)}
//                         />
//                       </div>

//                       <div className="tenant-entitlement-form-group tenant-entitlement-form-group--full">
//                         <label>Limits (JSON)</label>
//                         <textarea
//                           name="limits"
//                           value={ent.limits}
//                           onChange={(e) => handleChange(index, e)}
//                           placeholder='e.g. {"max_users": 50, "max_projects": 10}'
//                           rows={3}
//                           spellCheck={false}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 ))}

//                 {!isEditMode && (
//                   <button
//                     type="button"
//                     className="tenant-entitlement-add-btn"
//                     onClick={addEntitlement}
//                   >
//                     <span>+</span>
//                     Add Another Entitlement
//                   </button>
//                 )}
//               </div>
//             </div>

//             <div className="tenant-entitlement-form-actions">
//               <button
//                 type="button"
//                 className="tenant-entitlement-cancel-btn"
//                 onClick={handleCancel}
//                 disabled={loading}
//               >
//                 Cancel
//               </button>

//               <button
//                 type="submit"
//                 className="tenant-entitlement-save-btn"
//                 disabled={loading || loadingModules}
//               >
//                 {loading
//                   ? isEditMode
//                     ? "Updating..."
//                     : "Saving..."
//                   : isEditMode
//                   ? "Update Entitlement"
//                   : `Save ${entitlements.length} Entitlement${
//                       entitlements.length > 1 ? "s" : ""
//                     }`}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddTenantModuleEntitlement;

import React from "react";
import Sidebar from "../Layout/Sidebar";
import Header from "../Layout/Header";
import "./AddTenantModuleEntitlement.css";
import SubscriptionTabs from "../TenantSubscription/SubscriptionTabs";

const STATUS_LABELS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SUSPENDED: "Suspended",
  EXPIRED: "Expired"
};

// ---- Static data (no API) ----
const STATIC_ENTITLEMENTS = [
  {
    id: 1,
    module: "Core Platform",
    module_code: "CORE",
    status: "ACTIVE",
    effective_from: "2025-01-01",
    effective_to: "2026-01-01",
    limits: { max_users: 100, max_projects: 25 }
  },
  {
    id: 2,
    module: "Document Management",
    module_code: "DOCS",
    status: "ACTIVE",
    effective_from: "2025-01-01",
    effective_to: "2026-01-01",
    limits: { max_documents: 5000, max_storage_gb: 100 }
  },
  {
    id: 3,
    module: "Compliance & Audit",
    module_code: "COMP",
    status: "SUSPENDED",
    effective_from: "2025-03-15",
    effective_to: "2025-12-31",
    limits: { max_audits: 50 }
  },
  {
    id: 4,
    module: "Analytics & Reporting",
    module_code: "ANLY",
    status: "INACTIVE",
    effective_from: "2024-06-01",
    effective_to: "2025-06-01",
    limits: {}
  },
  {
    id: 5,
    module: "API Access",
    module_code: "API",
    status: "EXPIRED",
    effective_from: "2023-01-01",
    effective_to: "2024-01-01",
    limits: { rate_limit_per_minute: 60 }
  }
];

const toDateDisplay = (value) =>
  value ? String(value).substring(0, 10) : "-";

const stringifyLimits = (limits) => {
  if (!limits) return "-";
  if (typeof limits === "string") {
    const trimmed = limits.trim();
    if (!trimmed || trimmed === "{}") return "-";
    return trimmed;
  }
  if (typeof limits === "object") {
    const keys = Object.keys(limits);
    if (!keys.length) return "-";
    return JSON.stringify(limits);
  }
  return String(limits);
};

const AddTenantModuleEntitlement = () => {
  const getModuleLabel = (ent) => {
    if (ent.module_code) {
      return `${ent.module} (${ent.module_code})`;
    }
    return ent.module || "-";
  };

  const getStatusLabel = (value) => STATUS_LABELS[value] || value || "-";

  const entitlements = STATIC_ENTITLEMENTS;

  return (
    <div className="app-layout">
      <Sidebar />

      <div className="main-content">
        <Header />

        <div className="tenant-entitlement-page">
          <SubscriptionTabs />

          <div className="tenant-entitlement-page-header">
            <div>
              <h2>Module Entitlements</h2>
              <p>Tenant module entitlements list.</p>
            </div>
          </div>

          <div className="tenant-entitlement-list-card">
            {entitlements.length === 0 ? (
              <div className="tenant-entitlement-empty">
                <div className="tenant-entitlement-empty-icon">+</div>
                <h3>No Entitlements Found</h3>
                <p>
                  There are no module entitlements available for the current
                  tenant.
                </p>
              </div>
            ) : (
              <div className="tenant-entitlement-table-wrapper">
                <table className="tenant-entitlement-table">
                  <thead>
                    <tr>
                      <th>Module</th>
                      <th>Status</th>
                      <th>Effective From</th>
                      <th>Effective To</th>
                      <th>Limits</th>
                    </tr>
                  </thead>

                  <tbody>
                    {entitlements.map((ent) => (
                      <tr key={ent.id}>
                        <td>
                          <span className="tenant-entitlement-module-pill">
                            {getModuleLabel(ent)}
                          </span>
                        </td>

                        <td>
                          <span
                            className={`tenant-entitlement-status-pill status-${String(
                              ent.status || ""
                            ).toLowerCase()}`}
                          >
                            {getStatusLabel(ent.status)}
                          </span>
                        </td>

                        <td className="tenant-entitlement-muted">
                          {toDateDisplay(ent.effective_from)}
                        </td>

                        <td className="tenant-entitlement-muted">
                          {toDateDisplay(ent.effective_to)}
                        </td>

                        <td className="tenant-entitlement-muted">
                          <span className="tenant-entitlement-limits">
                            {stringifyLimits(ent.limits)}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTenantModuleEntitlement;